module.exports = __webpack_public_path__ + "img/residencial.537931e0.png";